import {
  CUSTOMER_PAGE,
  SHOP_PERFORMANCE_EVENTS,
  CL_TASKS_EVENTS,
  CONTEST_EVENTS,
  CL_KYC,
  GULLAK_EVENTS,
  VACATION_EVENTS,
  SIGNUP_FLOW_EVENTS,
  OTHER_EVENTS,
  DELIVERY_PAGE_EVENTS,
  ORDER_TRACKING,
  eventActionMapping,
  MY_DELIVERY_EVENTS,
} from "./analyticsEventsCT";

const LOCATION = [
  CUSTOMER_PAGE.CX_PAGE_NAME_CLICKED,
  CUSTOMER_PAGE.CX_PAGE_APP_SHARE,
  CUSTOMER_PAGE.CX_PAGE_CX_ADD,
  CUSTOMER_PAGE.CX_DETAIL_ALL_ORDERS,
  CUSTOMER_PAGE.CX_DETAIL_DELETE,
  CUSTOMER_PAGE.CX_DETAIL_CALL,
  SHOP_PERFORMANCE_EVENTS.CX_PAGE_NAME_CLICKED,
  CL_TASKS_EVENTS.CX_PAGE_NAME_CLICKED,
  CL_TASKS_EVENTS.DELETED_CUSTOMER_CLICKED,
  CL_KYC.KYC_LANDING,
  CL_KYC.KYC_SUBMIT,
  GULLAK_EVENTS.PAISE_NIKALE,
  GULLAK_EVENTS.TRANSACTION_SUCCESSFUL,
  GULLAK_EVENTS.TRANSACTION_FAILED,
  VACATION_EVENTS.MARK_LEAVE,
  VACATION_EVENTS.LEAVE_RULES,
  VACATION_EVENTS.LEAVE_SELECT,
  VACATION_EVENTS.LEAVE_SUBMIT,
  VACATION_EVENTS.VACATION_ORDER_CLICKED,
  VACATION_EVENTS.VIEW_ALL_ORDERS,
  SIGNUP_FLOW_EVENTS.SUCCESSFULL_REGISTRATION,
  SIGNUP_FLOW_EVENTS.SUCCESSFULL_LOGIN,
  SIGNUP_FLOW_EVENTS.RESEND_OTP,
  SIGNUP_FLOW_EVENTS.CHANGE_NUMBER,
  OTHER_EVENTS.CALL_SUPPORT,
  OTHER_EVENTS.ADD_CUSTOMER_CLICK,
  OTHER_EVENTS.APP_LAUNCH_FROM_APK,
  OTHER_EVENTS.APP_LAUNCHED_CUSTOM,
  OTHER_EVENTS.APP_LAUNCHED_CUSTOM_UTM,
  OTHER_EVENTS.ADD_CUSTOMER_SUCCESS,
  DELIVERY_PAGE_EVENTS.DELIVERY_SUCCESS,
  DELIVERY_PAGE_EVENTS.DELIVERY_FAIL,
  ORDER_TRACKING.DELIVERY_MARKED_BY_CL,
  ORDER_TRACKING.DB_CALL_BUTTON_CLICKED,
  eventActionMapping.unmarkDelivery,
  eventActionMapping.confirmPickup,
  eventActionMapping.confirmCancelPickup,
  eventActionMapping.unmarkPickup,
  MY_DELIVERY_EVENTS.DB_CALLED,
  MY_DELIVERY_EVENTS.CUSTOMER_CALLED,
];

export default {
  LOCATION,
};
